import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {Debugger} from "debug";
import {lesSubjectIdIkkeKnyttetTilBrukerModellFraStateParams} from "../../../felles/komponenter/autentisering/criiptoautentiseringBasis";
import {UIRouterGlobals} from "@uirouter/angularjs";
import {CriiptoBindBrukerFeiletForsøkÅrsak, CriiptoBindFraTokenSesjonstjeneste} from "web/tjenester/CriiptoBindFraTokenSesjonstjeneste";

const debug: Debugger = require('debug')('CriiptoBindBrukerKontroller');

const delt_scss = require('./delt.scss');
const forside_scss = require('./forside.scss');
const logginn_scss = require('./logginn.scss');
const criiptoBindBruker_scss = require('./criiptoBindBruker.scss');

/**
 * Håndterer binding av bruker til openid subject returnert av criipto.
 */
export class CriiptoBindBrukerKontroller {

    static regNavn = "web.CriiptoBindBrukerKontroller";

    static forInjisering() {
        return [
            regNavn.ng.ui.$uiRouterGlobals,
            Autentisering.regNavn,
            WebNavigasjon.regNavn,
            CriiptoBindFraTokenSesjonstjeneste.regNavn,
            CriiptoBindBrukerKontroller
        ]
    }

    constructor(
      private $uiRouterGlobals: UIRouterGlobals,
      private autentisering: Autentisering,
      private navigasjon: WebNavigasjon,
      private criiptoBindFraTokenSesjonstjeneste: CriiptoBindFraTokenSesjonstjeneste) {
        this.init();
    }

    //følgende blir populert fra $uiRouterGlobals
    subjectInfo: l.SubjectIdIkkeKnyttetTilBrukerModell;

    //følgende er lokale variable
    initiert = false;
    visBindSkjema = true;
    passordAutTokenvarighet = l.Tokenvarighet.kort;

    autentisert(autentisert: l.AutentisertOkModell) {
        // Bruker har nå fylt ut brukernavn og passord,
        // og er dermed autentisert. Koble autentisert bruker til criipto login
        debug('autentisert', autentisert);
        const spesifikasjon: l.CriiptoBindBrukerSpesifikasjon = {
            kryptertOpenIdIdentitet: this.subjectInfo.kryptertOpenIdIdentitet,
            tokenvarighet: this.subjectInfo.tokenvarighet
        }
        this.autentisering.bindAutentisertBrukerTilCriiptoSubject(spesifikasjon)
          .then(autentisert => {
              //bruker autentisert og bundet - vis bekreftelsesside
              this.visBindSkjema = false;
          })
          .catch(e => {
              //kryptert subject kan ha løpt ut på tid eller være ikke-dekrypterbar
              this.navigasjon.gåTilInnloggingssiden();
          });
    }

    neste() {
        this.navigasjon.gåTilStartsiden();
    }

    //hjelpemetoder

    private init() {
        this.subjectInfo = lesSubjectIdIkkeKnyttetTilBrukerModellFraStateParams(this.$uiRouterGlobals.params);

        if (this.subjectInfo == null) {
            debug('kryptertOpenIdIdentitet er tom, redirigerer til forsiden', this.$uiRouterGlobals)
            this.navigasjon.gåTilForsiden();
        }

        if (this.criiptoBindFraTokenSesjonstjeneste.epostOgTokenErSatt())
            this.bindVedHjelpAvResettoken()
        else
            this.initiert = true;
    }

    private bindVedHjelpAvResettoken(){
        this.autentisering.bindIkkeAutentisertBrukerTilCriiptoSubjectFraResettoken(
          {
              kryptertOpenIdIdentitet: this.subjectInfo.kryptertOpenIdIdentitet,
              tokenvarighet: this.subjectInfo.tokenvarighet,
              epost: this.criiptoBindFraTokenSesjonstjeneste.epost(),
              token: this.criiptoBindFraTokenSesjonstjeneste.token()
          }
        )
          .then(() => {
              this.navigasjon.gåTilInnloggingssiden();
          })
          .catch(reason => {
              // Håndter at kontoen allerede er knyttet til annen bankId
              if (reason.error?.kode == 406 /*NOT_ACCEPTABLE*/) {
                  this.criiptoBindFraTokenSesjonstjeneste.angiFeiletForsøkInformasjon(
                    CriiptoBindBrukerFeiletForsøkÅrsak.brukerAlleredeKnyttetTilEid,
                    this.criiptoBindFraTokenSesjonstjeneste.epost()
                  )
                  this.navigasjon.gåTilBindBrukerOpenIdFeilet()
              }
          })
          .finally(() => {
              this.criiptoBindFraTokenSesjonstjeneste.nullstill();
              this.initiert = true;
          });
    }
}
